module.exports = __webpack_public_path__ + "img/wawaji.6af437df.png";